<template>
  <div class="org-tree-container">
    <div class="org-tree" :class="{horizontal, collapsable}">
      <BlocksNode
          :data="data"
          :parent="data"
          :props="props"
          :index="0"
          :horizontal="horizontal"
          :label-width="labelWidth"
          :collapsable="collapsable"
          :render-content="renderContent"
          :label-class-name="labelClassName"
          @node-expand="(e, data,nodeContext) => $emit('node-expand', e, data,nodeContext)"
          @node-focus="(e, data,nodeContext) => $emit('node-focus', e, data,nodeContext)"
          @node-click="(e, data,nodeContext) => $emit('node-click', e, data,nodeContext)"
          @node-mouseover="(e, data,nodeContext) => $emit('node-mouseover', e, data,nodeContext)"
          @node-mouseout="(e, data,nodeContext) => $emit('node-mouseout', e, data,nodeContext)">
        <template #node="{data, context, parent, index}">
          <slot name="node" :data="data" :context="context" :parent="parent" :index="index"></slot>
        </template>
      </BlocksNode>
    </div>
  </div>
</template>

<script>

import BlocksNode from '@/components/tree/BlocksNode';

export default {
  name: 'blocks-tree',
  components: {
    BlocksNode,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    props: {
      type: Object,
      default: () => ({
        label: 'label',
        expand: 'expand',
        children: 'children',
        key: 'id',
      }),
    },
    horizontal: Boolean,
    collapsable: Boolean,
    renderContent: Function,
    labelWidth: [String, Number],
    labelClassName: [Function, String],
  },
};
</script>
